import { Form, Input } from "antd";
import { FC, ComponentType, useState } from "react";
import cn from "classnames";
import Carrier from "@Components/Carrier/Carrier";
import { withFloatingLabel } from "src/HOC/WithFloatingLabel";
import { SearchIcon, DefaultCheckIcon } from "src/assets/Icons";
import { NATIONALITIES } from "src/Seed/Countries/Countries";

const FloatingInput = withFloatingLabel(Input);

const NationalitySelectList: FC<{ value?: string; onChange?: (value: string) => void; closeSheet?: () => void }> = ({ value, onChange, closeSheet }) => {
  const [search, setSearch] = useState("");
  const filteredOptions = NATIONALITIES.filter((nationality) => nationality.label.toLowerCase().includes(search.toLowerCase()));
  const validationError = Form.Item.useStatus().errors;
  const hasValidationErrors = validationError.length >= 1;

  return (
    <div className="flex flex-col gap-2">
      <div className="outline-b outline-border-hover shadow-border-subtle sticky top-0 z-10 w-full bg-background-default p-4 shadow-sm">
        <div className="gap-2! outline-border-default focus-within:outline-border-active flex shrink-0 items-center justify-center rounded-md px-4 outline">
          <SearchIcon className="h-5 w-5 text-current" />
          <Input autoFocus value={search} onChange={(e) => setSearch(e.target.value)} variant="borderless" className="p-4!" />
        </div>
      </div>
      <div className="px-3">{hasValidationErrors && <div className="flex items-center justify-start text-font-danger">{validationError?.[0]}</div>}</div>

      <div className="flex w-full flex-col gap-2 px-3 py-1">
        {filteredOptions.map((nationality) => {
          const isSelected = nationality.value === value;
          return (
            <div
              key={nationality.value}
              className={cn(
                "flex w-full text-font-default cursor-pointer items-center justify-between rounded-sm p-2 font-semibold transition-all duration-300 hover:bg-background-primary-light",
                isSelected && "text-font-active!",
              )}
              onClick={() => {
                onChange?.(nationality.value);
                closeSheet?.();
              }}
            >
              {nationality.label}
              {isSelected && <DefaultCheckIcon className="h-4 w-4" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

type NationalitySelectMobProps = {
  name: string;
  rules: any[];
  icon: ComponentType<{ className?: string }>;
  label: string;
  hasError: boolean;
  onOpen?: () => void;
};

const NationalitySelectMob: FC<NationalitySelectMobProps> = ({ name, icon: Icon, label, hasError, rules, onOpen }) => {
  const value = Form.useWatch(name);
  const selectedLabel = NATIONALITIES.find((nationality) => nationality.value === value)?.label;
  return (
    <Carrier
      label={label}
      renderTrigger={({ open }) => (
        <div className={`flex w-full flex-1 items-center gap-1 px-1 border-b border-border-default ${hasError ? "text-font-danger" : "text-icon-minimal"}`}>
          <Icon className="h-4! w-4!" />
          <FloatingInput
            label={label}
            readOnly
            value={selectedLabel}
            onClick={() => {
              onOpen?.();
              open();
            }}
            className="text-font-default! border-none! outline-none! font-semibold shadow-none! pt-5! pb-1! px-3! w-full cursor-pointer"
          />
        </div>
      )}
      renderSheet={({ close }) => (
        <Form.Item name={name} rules={rules} className="m-0! w-full [&_.ant-form-item-explain-error]:hidden">
          <NationalitySelectList closeSheet={close} />
        </Form.Item>
      )}
    />
  );
};

export default NationalitySelectMob;
